import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasQueryProvider } from '../../shared/kit';
import App from './App';
import type { VideoPlayerInitData } from './types';
import './style.css';

/**
 * Entrée du player vidéo frontend React. Monte chaque
 * `[data-gas-video-player]` présent dans la page (plusieurs players possibles).
 */
function mountAll() {
    const nodes = document.querySelectorAll<HTMLElement>('[data-gas-video-player]');
    nodes.forEach(function (mountEl) {
        if (!mountEl.dataset.reactInit || !mountEl.isConnected || mountEl.dataset.gasMounted === '1') {
            return;
        }
        let initData: VideoPlayerInitData;
        try {
            initData = JSON.parse(mountEl.dataset.reactInit) as VideoPlayerInitData;
        } catch {
            return;
        }
        mountEl.dataset.gasMounted = '1';
        createRoot(mountEl).render(
            <React.StrictMode>
                <GasQueryProvider>
                    <App initData={initData} />
                </GasQueryProvider>
            </React.StrictMode>,
        );
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll, { once: true });
} else {
    mountAll();
}
